<soft-page [blockScrollY]="false" [customClass]="'!m-0 !p-0'">
  <soft-page-header customClass="!p-0">
    <div class="w-full">
      <soft-ds-progress-steps [steps]="steps()" />
    </div>
  </soft-page-header>

  <soft-page-panel
    [preferredWidth]="'3fr'"
    class="workflow-page-panel"
  >
    <!-- <div class="grid grid-rows-[auto_1fr] h-full p-4"> -->
    <div class="flex flex-col h-full min-h-0">
      <soft-ds-tabs
        variant="underline"
        class="w-full shrink-0"
        [tabs]="mergedTabs()"
        [(value)]="activeTab"
      />
      <div class="flex-1 min-h-0 overflow-auto">
        @if (isWorkflowTabActive()) {
          <soft-workflow-details-tab />
        } @else {
          <ng-content />
        }
      </div>
    </div>
  </soft-page-panel>

  <soft-page-panel
    [preferredWidth]="'1fr'"
    class="workflow-page-panel"
  >
    <section class="p-3">
      <div class="flex gap-1 text-primary font-semibold pb-4">
        <soft-ds-icon name="fa-regular fa-bolt-lightning" />
        <span class="uppercase">Aktionen</span>
      </div>
      <div class="flex flex-col gap-2">
        @for (action of workflow()?.actions; track action.title) {
          <soft-ds-button (click)="createNextAction(action)">
            {{ action.title }}
          </soft-ds-button>
        }
      </div>
    </section>
  </soft-page-panel>
</soft-page>
